import { styled as o } from "@mui/joy";
import m from "@mui/joy/Input";
import { commonBaseInputStyles as t } from "./common/commonBaseInputStyles.js";
const r = o(m)(({ theme: o2 }) => ({ ...t(o2) }));
export {
  r as BaseInput
};
//# sourceMappingURL=BaseInput.js.map
